import React from "react";

import { Link } from "react-router-dom";
import { Img } from "src/app/components/Img/Img";
import creatorPlaceholder from "src/images/person.svg";

import "./InfluencerPhotosCell.scss";
import LazyLoad from "react-lazy-load";

export function InfluencerPhotosCell({ headerLink, listItem }) {
  return (
    <LazyLoad>
      <Link
        to={headerLink}
        className="influencers-list__cell influencers-list__cell--photos"
      >
        {listItem?.userAvatars?.length > 0 ? (
          listItem?.userAvatars
            ?.slice(0, 3)
            .map((photo, index) => (
              <Img
                key={index}
                className="influencers-list__cell--photos__item"
                src={photo}
                fallbackImageSrc={creatorPlaceholder}
                loading="lazy"
              />
            ))
        ) : (
          <Img
            className="influencers-list__cell--photos__item"
            src={creatorPlaceholder}
            loading="lazy"
          />
        )}
      </Link>
    </LazyLoad>
  );
}
